import React from 'react';
import { FUNDING_DEAL_STAGE_STYLES } from '../../utils/funding/constants';

const FundingDealStageBadge = ({ stage }) => {
  if (!stage) return null;
  const style = FUNDING_DEAL_STAGE_STYLES[stage] || 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200';
  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${style}`}>
      {stage}
    </span>
  );
};

export default FundingDealStageBadge;
